module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About The Author")]), _vm._v(" "), _c('p', [_vm._v("After thirty years of law practice, Mary E. Martin embarked on her writing career. Inspired by her experiences in the law, she wrote the highly acclaimed "), _c('em', [_vm._v("Osgoode Trilogy")]), _vm._v(" about a lawyer named Harry Jenkins. Turning to her greatest passion, art, she then began "), _c('em', [_vm._v("The Trilogy of Remembrance,")]), _vm._v(" featuring a visionary landscape artist, Alexander Wainwright. "), _c('em', [_vm._v("The Wondrous Apothecary")]), _vm._v(" is a natural and exciting addition to that trilogy. She lives in Toronto with her husband. They have three children and three grandchildren.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73071bfe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch001.vue
// module id = 63
// module chunks = 0